import React from 'react';
import background from '../../assets/grasshopper.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoGrasshopper extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Grasshoppers"
        paragraph="Warming sea surface temperatures are forcing populations of the American lobster (Homarus americanus) to higher latitudes than ever before—and upending fishing communities on the New England coast."
        background={background}
     />
  
  );
 }
}   

export default InfoGrasshopper;